import { addUpperIndex, validationRules } from '../../constants';
import { getSelectPopupContainer } from '../utils/getSelectPopupContainer';

export const firstAndSecondLinesFields = [
  {
    label: 'Наименование помещения',
    name: 'name',
    getInitialValue: (room) => room?.name,
    rules: [validationRules.required('Укажите наименование помещения')],
    inputProps: { placeholder: 'Введите наименование помещения' },
  },
  {
    label: 'Кадастровый номер помещения',
    name: 'cadastralNumber',
    getInitialValue: (room) => room?.cadastralNumber,
    // rules: [validationRules.required('Укажите кадастровый номер')],
    inputProps: { placeholder: 'Введите кадастровый номер' },
  },
];

export const thirdLineFields = [
  {
    label: 'Этаж',
    name: 'floor',
    getInitialValue: (room) => room?.floor && String(room.floor),
    rules: [validationRules.required('Укажите этаж'), validationRules.integer],
    inputProps: { suffix: 'этаж' },
  },
  {
    label: 'Номер помещения',
    name: 'number',
    getInitialValue: (room) => room?.number,
    rules: [validationRules.required('Укажите номер помещения')],
    inputProps: { placeholder: 'Введите номер помещения' },
    validateStatus: (numberError) => (numberError ? 'error' : undefined),
    help: (numberError) =>
      numberError ? 'Номер помещения уже существует.' : undefined,
  },
  {
    label: 'Площадь',
    name: 'area',
    getInitialValue: (room) => room?.area && String(room.area),
    rules: [
      validationRules.required('Укажите площадь'),
      validationRules.number,
    ],
    inputProps: { suffix: addUpperIndex('м', '2') },
  },
];

export const fourthLineSelectFields = [
  {
    label: 'Статус аренды',
    name: 'status',
    getInitialValue: (room) => room?.status?.id,
    rules: [validationRules.required('Укажите статус аренды', 'number')],
    selectProps: {
      placeholder: 'Выбрать из списка',
      getPopupContainer: getSelectPopupContainer,
    },
  },
  {
    label: 'Тип помещения',
    name: 'type',
    getInitialValue: (room) => room?.type?.id,
    rules: [validationRules.required('Укажите тип помещения', 'number')],
    selectProps: {
      placeholder: 'Выбрать из списка',
      getPopupContainer: getSelectPopupContainer,
    },
  },
];

export const textAreaField = [
  {
    label: 'Описание',
    name: 'description',
    getInitialValue: (room) => room?.description?.description,
    areaProps: { rows: 3, placeholder: 'Описание помещения' },
  },
  {
    label: 'Комментарий',
    name: 'comment',
    getInitialValue: (room) => room?.comment,
    areaProps: { rows: 3, placeholder: 'Ваш комментарий' },
  },
];
